import { render, staticRenderFns } from "./NameStatus.vue?vue&type=template&id=587e2721&"
import script from "./NameStatus.vue?vue&type=script&lang=js&"
export * from "./NameStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports